import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
type ComposerDisclaimerProps = {
  className?: string;
};
const ComposerDisclaimer = t0 => {
  const $ = _c(7);
  const {
    className
  } = t0;
  const {
    t
  } = useTranslation("ask-percy");
  let t1;
  if ($[0] !== className) {
    t1 = cx("mt-3 text-center text-balance text-caption-3 font-normal text-tertiary group-data-[keyboard-open]/app:hidden", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t(_temp);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <p className={t1}>{t2}</p>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default ComposerDisclaimer;
function _temp($) {
  return $.disclaimer;
}